import { styled } from '@mui/material/styles';
import Card from '@mui/material/Card';

export const StyledContainer = styled('div')(({ theme }) => ({
  backgroundColor: '#ebe9e1',
  display: 'flex',
  justifyContent: 'center',
  padding: '2em',
  minWidth: 600,
  textAlign: 'justify',
  textJustify: 'inter-word',
  [theme.breakpoints.down('lg')]: {
    padding: 'unset',
  },
}));

export const StyledCardStyle = styled(Card)(({ theme }) => ({
  padding: '2em',
  width: '75%',
  [theme.breakpoints.down('xl')]: {
    width: '80%',
  },
  [theme.breakpoints.down('lg')]: {
    padding: '1em',
    width: '90%',
  },
  [theme.breakpoints.down('md')]: {
    width: '100%',
  },
}));
